import { render, staticRenderFns } from "./VolunteerPreview.vue?vue&type=template&id=7c7180f0&scoped=true"
import script from "./VolunteerPreview.vue?vue&type=script&lang=ts"
export * from "./VolunteerPreview.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerPreview.vue?vue&type=style&index=0&id=7c7180f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7180f0",
  null
  
)

export default component.exports